import { FileNotFoundGitError } from '../errors/file-not-found.git-error';
import type { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import type { FSAction } from './actions.enum';

export interface FSDeleteFileAction extends WorkerAction {
  type: FSAction.DeleteFile;
  params: { path: string; skipSync?: boolean };
}

export async function FSDeleteFileActionFn({ fs, params, util }: WorkerFnParams<FSDeleteFileAction>): Promise<void> {
  const { path, skipSync } = params;

  const exists = util.itemExistsAt(path);
  if (!exists) {
    throw new FileNotFoundGitError(path);
  }

  fs.unlink(path);

  if (!skipSync) {
    await util.syncfs(false);
  }
}
